import React from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import SglContext from "../SglContext";
import ClassHeader from "./classHeader";

import ClassEntries from "./classEntries";
import ClassOrder from "./classOrder";
import ClassResult from "./classResult";
import "./classes.css";

class ClassDetail extends React.Component {
  state = {
    class_details: [],
    trips: [],
    cdm_data: [],
    related_data: {},
    jumper_table_info: {},
    default_tab: "entries",
    current_tab: "",
    current_show:
      this.getQueryVariable("sid") && this.getQueryVariable("sid") != ""
        ? this.getQueryVariable("sid")
        : localStorage.getItem("show_id"),
    userData: {},

    videos_list: [],
    video_to_play: {},
    playing_video: false,
    is_open_play_video_modal: false,
    is_open_do_subscription_modal: false,
    is_admin: false,

    loading: true,
    flag_img_dir: this.importAll(
      require.context("../images/Flags/Large", false, /\.(png|jpe?g|svg)$/)
    ),
    ip_address: "",
    team_scoring_result: {},
    result_trips:[],
    class_group_order_of_go: [],
  };
  constructor() {
    super();
    this.VideoPlayerElement = React.createRef();
    this.VideoSubscriptionElement = React.createRef();
    // bind function in constructor instead of render
    this.closeModal = this.closeModal.bind(this);
    this.closeSubscriptionModal = this.closeSubscriptionModal.bind(this);
    this.playVideoAfterSubscribe = this.playVideoAfterSubscribe.bind(this);
  }

  importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  }

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  componentDidMount() {
    this.getClassDetails();
    this.getClassStatus();
  }
  async getClassStatus() {
    await axios
      .get(
        this.context.sglApiUrl +
          "/iphonev2/index.php/" +
          this.context.company_urlpath +
          "/liveclassv2/ClassStatus",
        {
          params: {
            from_wp_api: true,
            class_id: this.getQueryVariable("cid"),
            show_id: this.getQueryVariable("sid"),
            ring: this.getQueryVariable("ring")
              ? this.getQueryVariable("ring")
              : null,
            from_live_class: 0,
          },
        }
      )
      .then((res) => {
        if (res.data.is_live) {
          var cgid = this.getQueryVariable("cgid")
            ? this.getQueryVariable("cgid")
            : res.data.class_group_id;
          var ring = this.getQueryVariable("ring")
            ? this.getQueryVariable("ring")
            : res.data.ring;

          let old = this.getQueryVariable("old");
          if (!old) {
            const { navigate } = this.props;
            navigate(
              "/liveclass/detail?cid=" +
                this.getQueryVariable("cid") +
                "&sid=" +
                this.getQueryVariable("sid") +
                "&class_group_id=" +
                cgid +
                "&ring=" +
                ring
            );
          }
        }
      });
  }
  async getClassDetails() {
    this.getUserData();
    this.getClassVideos();
    await axios
      .all([
        await axios.get(
          this.context.nestApiUrl +
            "/classes/" +
            this.getQueryVariable("cid"),
          {
            params: {
              show_id: this.getQueryVariable("sid"),
              customer_id: this.context.company_id,
              cgid: this.getQueryVariable('cgid') ? this.getQueryVariable('cgid'): "-1",
            },
          }
        ),
        
      ])
      .then(
        axios.spread((res) => {
          let current_tab = "Entries",
            default_tab = this.state.default_tab;
          if (res.data.class_related_data.status == "Completed") {
            default_tab = "result";
            current_tab = "Results";
          } else if (res.data.class.order_of_go_set == 1) {
            default_tab = "order";
            current_tab = "Order";
          }
          this.setState({
            class_details: res.data.class,
            trips: res.data.trips,
            related_data: res.data.class_related_data,
            jumper_table_info: res.data.jumper_table_info,
            current_show: res.data.show_id,
            loading: false,
            cdm_data: res.data.cdm_data,
            current_tab,
            default_tab,
            team_scoring_result: res.data.team_scoring_result,
            result_trips: [...res.data.trips], 
            class_group_order_of_go: res.data.class_group_order_of_go.entries
          });
          document.title =
            "Class " + res.data.class.number + " - " + res.data.class.name;
          this.context.reportToGA(
            "/sgl-wp-plugin/" +
              this.context.company_urlpath +
              "/" +
              this.getQueryVariable("sid") +
              "/classes/detail/" +
              this.getQueryVariable("cid")
          );
          this.context.reportToFB(
            "/sgl-wp-plugin/" +
              this.context.company_urlpath +
              "/" +
              this.getQueryVariable("sid") +
              "/classes/detail/" +
              this.getQueryVariable("cid")
          );
        })
      );
  }
  async getClassVideos() {
    await axios
      .get(
        this.context.nestApiUrl +
          "/classes/" +
          "videos/" +
          this.getQueryVariable("cid"),
        {
          params: {
            show_id: this.getQueryVariable("sid"),
            customer_id: this.context.company_id,
          },
        }
      )
      .then((res) => {
        this.setState({
          videos_list: res.data.exc_videos,
        });
      });
  }
  async getUserData() {
    await axios.get(this.context.nestApiUrl + "/users/getUser").then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          this.setState({
            userData: response.data.user,
          });
          if (
            localStorage.getItem("playing_video_id") &&
            localStorage.getItem("playing_video_url") ==
             window.location.pathname.replace(this.context.basePath, '') + window.location.search
          ) {
            this.playVideoAPICall(localStorage.getItem("playing_video_id"));
          }
        } else {
        }
      },
      (error) => {}
    );
  }
  playVideo = (video_id) => (e) => {
    this.playVideoAPICall(video_id);
  };
  async playVideoAPICall(video_id) {
    localStorage.setItem("playing_video_id", video_id);
    localStorage.setItem("playing_video_url", window.location.pathname.replace(this.context.basePath, '') + window.location.search);
    await axios
      .get(this.context.nestApiUrl + "/videos/play/" + video_id, {
        params: {
          customer_id: this.context.company_id,
        },
      })
      .then((res) => {
        this.closeSubscriptionModal();
        localStorage.removeItem("playing_video_id");
        localStorage.removeItem("playing_video_url");
        if (res.data.subscribed_to_play) {
          this.setState({
            video_to_play: res.data.video,
            is_admin: res.data.is_admin,
            is_open_play_video_modal: true,
            playing_video: true,
          });
        } else {
          this.setState({
            video_to_play: res.data.video,
            is_admin: res.data.is_admin,
            is_open_do_subscription_modal: true,
            playing_video: true,
          });
        }
      });
  }

  closeModal() {
    this.setState({
      is_open_play_video_modal: false,
      playing_video: false,
    });
  }
  closeSubscriptionModal() {
    this.setState({
      is_open_do_subscription_modal: false,
      playing_video: false,
    });
  }
  playVideoAfterSubscribe() {
    this.playVideoAPICall(this.state.video_to_play.videos_sgl_id);
    this.setState({
      playing_video: true,
    });
  }

  getVideoTitle(video) {
    if (video["class_type"] == "Jumpers") {
      if (video["trip_type"].toLowerCase() != "jo") {
        return " - Round 1";
      } else {
        return " - Jump Off";
      }
    }
  }

  openSection = (split) => (e) => {
    var i, all_sections, selected_section, sectionLink;
    selected_section = document.getElementsByClassName("split_" + split);
    all_sections = document.getElementsByClassName("section");
    for (i = 0; i < all_sections.length; i++) {
      all_sections[i].style.display = "none";
    }

    for (i = 0; i < selected_section.length; i++) {
      selected_section[i].style.display = "table-row";
    }
    sectionLink = document.getElementsByClassName("sectionLink");
    for (i = 0; i < sectionLink.length; i++) {
      sectionLink[i].className = sectionLink[i].className.replace(
        " active",
        ""
      );
    }
    e.currentTarget.className += " active";
  };

  getFaultTime(time_faults, faults, time, round_no, placing, is_result) {
    var JOQualified = false;

    if (this.state.jumper_table_info && this.state.jumper_table_info.hasJO) {
      if (time_faults) {
        JOQualified = false;
      } else {
        JOQualified = true;
      }
    }

    var hasPlacing = placing > 0 && placing != 100000;
    var hasJOScore = hasPlacing && JOQualified;

    var total_faults = time_faults + faults;
    if (time > 0) {
      var time_string = time.toString();
      if (
        this.state.jumper_table_info &&
        this.state.jumper_table_info.fei_rule
      ) {
        time = time_string.slice(0, time_string.indexOf(".") + 3);
      } else {
        time = time_string.slice(0, time_string.indexOf(".") + 4);
      }
      return total_faults + " | " + time;
    } else if (is_result) {
      if ((round_no == 1 && hasPlacing) || (round_no == 2 && hasJOScore)) {
        return "N/A";
      } else {
        return " - ";
      }
    } else {
      return " - ";
    }
  }

  format_currancy(amount) {
    return (
      "$" + (Math.round(amount) && Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    );
  }

  openTab = (tabName) => (e) => {
    this.setState({ current_tab: tabName });
  };

  // getVideosList(uuid) {
  //   var trip = this.state.videos_list.find((v) => v.uuid == uuid);
  //   if (trip) {
  //     var videos = trip.videos;
  //     return videos;
  //   }
  //   return [];
  // }

  render() {
    var current_tab = this.state.current_tab;
    const cmd_state = this.state.cdm_data;
    const loading = this.state.loading;
    const trips = this.state.trips.length;
    let cdm_button;
    if (cmd_state.length === 0) {
      cdm_button = "";
    } else {
      cdm_button = (
        <button
          className={["tablinks", "active"].join(" ")}
          onClick={this.openTab("CDM")}>
          Course Design Maps
        </button>
      );
    }

    if (loading) {
      return null;
    }

    return (
      <div className='sgl-plugin section-to-print classescss'>
        <ClassHeader
          related_data={this.state.related_data}
          class_details={this.state.class_details}
          jumper_table_info={this.state.jumper_table_info}
        />
        {this.state.class_details.combined_class_id > 0 ? (
          <>
            This class is combined to{" "}
            {this.state.class_details.combined_class_number}.{" "}
            <Link
              to={
                "/classes/detail?cid=" +
                this.state.class_details.combined_class_id
              }>
              Click here
            </Link>{" "}
            to go to the class.
          </>
        ) : (
          <>
            {trips > 0 ? (
              <div className='details'>
                <div className='tab'>
                  <button
                    className={
                      current_tab === "Entries"
                        ? ["tablinks", "active"].join(" ")
                        : "tablinks"
                    }
                    onClick={this.openTab("Entries")}>
                    Entries
                  </button>
                  <button
                    className={
                      current_tab === "Order"
                        ? ["tablinks", "active"].join(" ")
                        : "tablinks"
                    }
                    onClick={this.openTab("Order")}>
                    Order of Go
                  </button>
                  <button
                    className={
                      current_tab === "Results"
                        ? ["tablinks", "active"].join(" ")
                        : "tablinks"
                    }
                    onClick={this.openTab("Results")}>
                    Results
                  </button>
                  {cdm_button}
                </div>

                <div
                  id='Entries'
                  className={
                    current_tab === "Entries"
                      ? ["tabcontent", "display_block"].join(" ")
                      : ["tabcontent", "display_none"].join(" ")
                  }>
                  <ClassEntries
                    class_details={this.state.class_details}
                    related_data={this.state.related_data}
                    current_show={this.state.current_show}
                    trips={this.state.trips}
                    flag_img_dir={this.state.flag_img_dir}
                    videos_list={this.state.videos_list}
                    jumper_table_info={this.state.jumper_table_info}
                    playing_video={this.state.playing_video}
                    openSection={this.openSection}
                    getVideosList={this.getVideosList}
                    playVideo={this.playVideo}
                    getVideoTitle={this.getVideoTitle}
                    format_currancy={this.format_currancy}
                    getFaultTime={this.getFaultTime}
                    closeModal={this.closeModal}
                    closeSubscriptionModal={this.closeSubscriptionModal}
                    playVideoAfterSubscribe={this.playVideoAfterSubscribe}
                    VideoSubscriptionElement={this.VideoSubscriptionElement}
                    VideoPlayerElement={this.VideoPlayerElement}
                    is_open_play_video_modal={
                      this.state.is_open_play_video_modal
                    }
                    is_open_do_subscription_modal={
                      this.state.is_open_do_subscription_modal
                    }
                    video_to_play={this.state.video_to_play}
                    is_admin={this.state.is_admin}
                  />
                </div>

                <div
                  id='Order'
                  className={
                    current_tab == "Order"
                      ? ["tabcontent", "display_block"].join(" ")
                      : ["tabcontent", "display_none"].join(" ")
                  }>
                  {" "}
                  <ClassOrder
                    class_details={this.state.class_details}
                    related_data={this.state.related_data}
                    current_show={this.state.current_show}
                    trips={this.state.trips}
                    flag_img_dir={this.state.flag_img_dir}
                    videos_list={this.state.videos_list}
                    jumper_table_info={this.state.jumper_table_info}
                    playing_video={this.state.playing_video}
                    openSection={this.openSection}
                    getVideosList={this.getVideosList}
                    playVideo={this.playVideo}
                    getVideoTitle={this.getVideoTitle}
                    format_currancy={this.format_currancy}
                    getFaultTime={this.getFaultTime}
                    closeModal={this.closeModal}
                    closeSubscriptionModal={this.closeSubscriptionModal}
                    playVideoAfterSubscribe={this.playVideoAfterSubscribe}
                    VideoSubscriptionElement={this.VideoSubscriptionElement}
                    VideoPlayerElement={this.VideoPlayerElement}
                    is_open_play_video_modal={
                      this.state.is_open_play_video_modal
                    }
                    is_open_do_subscription_modal={
                      this.state.is_open_do_subscription_modal
                    }
                    video_to_play={this.state.video_to_play}
                    is_admin={this.state.is_admin}
                    classGroupOrderOfGo={this.state.class_group_order_of_go}
                  />
                </div>

                <div
                  id='Results'
                  className={
                    current_tab == "Results"
                      ? ["tabcontent", "display_block"].join(" ")
                      : ["tabcontent", "display_none"].join(" ")
                  }>
                  {" "}
                    <ClassResult
                      class_details={this.state.class_details}
                      related_data={this.state.related_data}
                      current_show={this.state.current_show}
                      trips={this.state.trips}
                      flag_img_dir={this.state.flag_img_dir}
                      videos_list={this.state.videos_list}
                      jumper_table_info={this.state.jumper_table_info}
                      playing_video={this.state.playing_video}
                      openSection={this.openSection}
                      getVideosList={this.getVideosList}
                      playVideo={this.playVideo}
                      getVideoTitle={this.getVideoTitle}
                      format_currancy={this.format_currancy}
                      getFaultTime={this.getFaultTime}
                      closeModal={this.closeModal}
                      closeSubscriptionModal={this.closeSubscriptionModal}
                      playVideoAfterSubscribe={this.playVideoAfterSubscribe}
                      VideoSubscriptionElement={this.VideoSubscriptionElement}
                      VideoPlayerElement={this.VideoPlayerElement}
                      is_open_play_video_modal={
                        this.state.is_open_play_video_modal
                      }
                      is_open_do_subscription_modal={
                        this.state.is_open_do_subscription_modal
                      }
                      video_to_play={this.state.video_to_play}
                      is_admin={this.state.is_admin}
                      result_trips={this.state.result_trips}
                      team_scoring_result={this.state.team_scoring_result} 
                      />
                </div>
              </div>
            ) : (
              <div>There are currently no entries in this class</div>
            )}
          </>
        )}

        <div className='copyright-text'>
          {" "}
          {process.env.REACT_APP_COPYRIGHT_TEXT}
        </div>
      </div>
    );
  }
}
ClassDetail.contextType = SglContext;
// ClassDetail.navigate = useNavigate;
export default function(props) {
  const navigate = useNavigate();

  return <ClassDetail {...props} navigate={navigate} />;
}
